import axios from "axios";

const API_URL = "/api/mail/";

// Send Mail
export const sendMailToOthers = async (emailData, config) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}${API_URL}`,
    emailData,
    config
  );

  return response.data;
};

// Generate Mail
export const generateMailApi = async (config) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}${API_URL}generate`,
    config
  );

  if (response.data) {
    localStorage.setItem("generatedmail", JSON.stringify(response.data));
  }

  return response.data;
};

// Get Inbox List Mail
export const inboxMailApi = async (email) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}${API_URL}${email}`
  );

  return response.data;
};

// Get Read Inbox Mail
export const readInboxMailApi = async (email, mailId) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}${API_URL}${email}/${mailId}`
  );

  return response.data;
};
